import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../core/i18n/language.service';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ResponsiveImageDirective } from '../../shared/directives/responsive-image.directive';
import { GoogleMapsComponent } from '../../shared/components/google-maps/google-maps.component';
import { createWhatsAppUrl } from '../../shared/utils/whatsapp-url.util';
import { APP_CONSTANTS } from '../../shared/constants/app-constants';
import { FACEBOOK, HOME_PIN, INSTAGRAM, LETTER, PHONE, TIKTOK } from '../../shared/constants/svg/svg-icons';

interface LinkSection {
  link: string,
  label: string,
  icon: string;
  newTab?: boolean;
  translationKey?: string;
};

@Component({
  selector: 'app-contact',
  imports: [TranslatePipe,
    GoogleMapsComponent, RouterLink, ResponsiveImageDirective,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  readonly language = inject(LanguageService);
  private readonly translate = inject(TranslateService);
  get whatsappLink(): string {
    this.language.current();
    return createWhatsAppUrl(APP_CONSTANTS.FUNCTIONAL_PHONE, this.translate.instant('common.whatsappInquiry'));
  }
  readonly GOOGLE_MAPS_LOCATION = APP_CONSTANTS.GOOGLE_MAPS_LOCATION;

  readonly contactContent: LinkSection[] = [
    {
      icon: HOME_PIN,
      label: APP_CONSTANTS.ADRESS,
      translationKey: 'common.address',
      link: this.GOOGLE_MAPS_LOCATION,
      newTab: true
    },
    {
      icon: LETTER,
      label: APP_CONSTANTS.MAIL,
      link: 'mailto:' + APP_CONSTANTS.MAIL,
      newTab: false
    },
    {
      icon: PHONE,
      label: APP_CONSTANTS.DISPLAY_PHONE,
      link: 'tel:+' + APP_CONSTANTS.FUNCTIONAL_PHONE,
      newTab: false
    },
  ];

  readonly socialContent: LinkSection[] = [
    {
      icon: FACEBOOK,
      label: 'Facebook',
      link: 'https://www.facebook.com/profile.php?id=61559028520422'
    },
    {
      icon: INSTAGRAM,
      label: 'Instagram',
      link: 'https://www.instagram.com/sohtinyhouse/'
    },
    {
      icon: TIKTOK,
      label: 'TikTok',
      link: 'https://www.tiktok.com/@sohtinyhouse'
    },
  ];
}
